export const rootColors = {
  bgColor: "#121212",
  grey: "#1B1B1B",
  primary: "#36AA9C",
  text: "#FFFFFF",
};
